import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import SaleFooter from '../SaleFooter/SaleFooter';
import {goToPage, reportAnalytics, setIsSubmit, setIsValid, setCustomerEmail, setIsReceivingBill} from '../saleBlockSlice';
import CustomerEmail from '../CustomerEmail/CustomerEmail';

const EmailPage = (props) => {
  let saleType = props.saleType;
  let flowType = props.flowType;

  useEffect(() => {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    switch (saleType) {
      case 'tv':
        props.reportAnalytics({eventCategory: 'tv_newsale_process', eventAction: 'visibility_12', eventLabel: eventLabel});
        break;
      case 'app':
        //props.reportAnalytics({ eventCategory: 'app_newsale_process', eventAction: 'visibility_13', eventLabel: eventLabel });
        break;
      case 'cellular':
        props.reportAnalytics({eventCategory: 'cellular_newsale_process', eventAction: 'visibility_13', eventLabel: 'screen_8'});
        break;
      case 'internet':
        props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: 'visibility_26', eventLabel: eventLabel});
        break;
    }
  }, []);

  //page params
  let isDisplayFooter = true;
  let btnText = 'ממשיכים לסיכום';
  let currentPageFunction = handleEmailPageContinue;
  let totalPrice = null;
  let priceText = 'לחודש';
  let formid = 'sale';
  //page params

  let title = null;
  let subTitle = '';

  if (saleType == 'tv') {
    title = `מה יהיה המייל שלכם ב${window.Config.brand_Name_HE} TV?`;
  } else {
    title = 'לאיזה מייל לשלוח את החשבונית?';
    subTitle = 'לכתובת זו יישלחו הוראות להפעלת ה-eSIM';
  }

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      <h1 className='sale-title-big'>{title}</h1>
      {props.esimData?.saleType == 'MIXED' || props.esimData?.saleType == 'ESIMONLY' ? (
        <label className='sale-esim-sub-title'>
          <Image src={require('../images/icon-24-light.svg')} alt='light-icon' className='img-light-icon' />
          {subTitle}
        </label>
      ) : null}
    </div>
  );

  let currentPageView = (
    <CustomerEmail customerEmail={props.personalInfo} onValid={handleCustomerEmailValidate} onSubmit={props.isSubmit} saleType={saleType} />
  );

  function handleEmailPageContinue() {
    props.setIsSubmit({isSubmit: true});
  }

  function handleCustomerEmailValidate(valid) {
    props.setIsSubmit({isSubmit: false});
    if (valid) {
      handleEmailPageContinueAfterValid();
    }
    props.setIsSubmit({isSubmit: false});
  }

  function handleEmailPageContinueAfterValid() {
    props.setCustomerEmail({email: props._customerEmail.form.email});
    props.setIsReceivingBill({isReceivingBill: props._customerEmail.isReceivingBill});

    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    switch (saleType) {
      case 'tv':
        props.reportAnalytics({eventCategory: 'tv_newsale_process', eventAction: 'click_17', eventLabel: eventLabel});
        break;
      case 'cellular':
        eventLabel = props._customerEmail.isReceivingBill ? 'אני רוצה לקבל את החשבונית למייל שהזנתי' : 'אל תשלחו לי לכאן את החשבונית';
        props.reportAnalytics({eventCategory: 'cellular_newsale_process', eventAction: 'click_28', eventLabel: eventLabel});
        break;
      case 'internet':
        props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: 'click_36', eventLabel: eventLabel});
        break;
    }

    let pageData = {};

    switch (saleType) {
      case 'tv':
        if (flowType == 'existsCustomer') {
          pageData = {page: 'summaryPage', percent: 88};
        } else {
          pageData = {page: 'summaryPage', percent: 81};
        }
        break;
      case 'cellular':
        pageData = {page: 'summaryPage', percent: 84};
        break;
      case 'internet':
        if (props.configuration.isDisplaySuperWifi) {
          props.goToPage({page: 'meshUpgradePage', percent: 72});
        } else {
          props.goToPage({page: 'summaryPage', percent: 80});
        }
        return;
    }

    props.goToPage(pageData);
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    totalPrice: state.saleBlock.totalPrice,
    isSubmit: state.saleBlock.isSubmit,
    isValid: state.saleBlock.isValid,
    configuration: state.saleBlock.epiServer.configuration,
    personalInfo: state.saleBlock.personalInfo,
    productsInfo: state.saleBlock.productsInfo,
    esimData: state.saleBlock.esim,
    //other states
    _customerEmail: state.CustomerEmail,
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  setIsSubmit,
  setIsValid,
  setCustomerEmail,
  setIsReceivingBill,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailPage);
